<template>
    <div class="personal-loan-status-setting">
				<StatusMenu :tab_name="'personalLoanStatus'"  v-if="_gAuth.isAppSas()"/>
        <CreateNewPersonalLoanStatusModal :create_new_personal_loan_status.sync="modals.create_new_personal_loan_status"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Personal Loan Status Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <PersonalLoanStatusTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import StatusMenu from '@/views/Configurations/StatusMenu'
import PersonalLoanStatusTable from '@/views/Configurations/PersonalLoanStatusSettings/PersonalLoanStatusTable'
import CreateNewPersonalLoanStatusModal from '@/views/Configurations/PersonalLoanStatusSettings/PersonalLoanStatusModals/CreateNewPersonalLoanStatusModal'

export default {
    components: {
        PersonalLoanStatusTable,
        RouteBreadCrumb,
        CreateNewPersonalLoanStatusModal,
				StatusMenu
    },
    data() {
        return {
            modals: {
                create_new_personal_loan_status: false
            }
        }
    },
    methods: {
        openModal() {
            this.modals.create_new_personal_loan_status = true;
        },
        closeModal(){
            this.modals.create_new_personal_loan_status = false;
        },
    }
}
</script>